/**
 * Where a fan lands after creating or joining a pool from the Pools section.
 *
 * Only the list's `q` filter survives, the way `goBackToPoolsList` in
 * `routes/pools.tsx` keeps it. Every other key belonged to the pool the fan
 * was looking at (ISSUE-1034), and carrying `contestId` or `roundId` onto a
 * different pool would point the new pool at the old pool's contest.
 */
import type { typePoolsSearch } from "../../routeState/sectionSearch";

export function openEnteredPoolSearch(
  search: typePoolsSearch,
  poolId: string,
): { q?: string; poolId: string } {
  if (search.q === undefined) {
    return { poolId };
  }
  return { q: search.q, poolId };
}
